<template>
  <div>
    <div v-show="ui.step === 0">
      <img src="img/consent/pers-1.png">
      <p class="text-xs-center">Vous avez été pré-inscrit(e) au programme Applidrep.</p>
      <p class="text-xs-center primary--text fw500">Vous devez maintenant compléter votre inscription pour activer votre suivi.</p>
      <p class="text-xs-center">Cela se fait en 3 étapes et prend 2 minutes seulement.</p>
      <v-btn block
             round
             class="primary mt-4"
             @click="ui.step++">Commencer
      </v-btn>
    </div>

    <div v-show="ui.step === 1">
      <h3 class="mt-2 primary--text text-xs-center fw500">Etape 1/3</h3>
      <v-progress-linear class="mb-4"
                         :value="20"></v-progress-linear>

      <p>Vérifiez que les <span class="primary--text fw500">moyens de contact</span> indiqués ci-dessous sont corrects, corrigez si besoin :</p>
      <p>Ils seront utilisés pour vous prévenir lors d'une <span class="primary--text fw500">nouvelle étape de votre suivi</span>, ou d'un <span class="primary--text fw500">message de votre soignant.</span></p>
      <v-text-field placeholder="Adresse e-mail"
                    outlined
                    label="Adresse e-mail"
                    type="email"
                    v-model="user.email"></v-text-field>

      <v-text-field placeholder="Numéro de téléphone"
                    outlined
                    label="N° de téléphone"
                    mask="## ## ## ## ##"
                    type="tel"
                    v-model="user.phoneNumber"></v-text-field>

      <v-btn block
             round
             class="primary"
             @click="ui.step++">Confirmer
      </v-btn>
    </div>

    <div v-show="ui.step === 2">
      <h3 class="mt-2 primary--text text-xs-center fw500">Etape 2/3</h3>
      <v-progress-linear class="mb-4"
                         :value="40"></v-progress-linear>

      <p class="mt-4">Votre identifiant de connexion : </p>
      <p class="text-center primary--text fw500">{{ user.username }}</p>

      <p>Choisissez le mot de passe qui servira à protéger votre compte Applidrep.</p>
      <v-text-field placeholder="Mot de passe"
                    outlined
                    label="Choisir un mot de passe"
                    required
                    type="password"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    v-model="user.password"></v-text-field>
      <v-text-field placeholder="Confirmer le mot de passe"
                    outlined
                    label="Confirmer le mot de passe"
                    required
                    type="password"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    v-model="password2"></v-text-field>

      <MangoCaption>NB : notez votre nom d'utilisateur et mot de passe, ils vous seront demandés lors de vos connexions ultérieures à Applidrep.</MangoCaption>

      <v-btn block
             round
             class="primary"
             @click="ui.step++"
             :disabled="!user.password || user.password !== password2">Continuer
      </v-btn>
    </div>

    <div v-show="ui.step === 3">
      <h3 class="mt-2 primary--text text-xs-center fw500">Etape 3/3</h3>
      <v-progress-linear class="mb-4"
                         :value="100"></v-progress-linear>

      <div class="px-2 py-1 mb-4"
           style="height: 200px; overflow-y: scroll; border: 1px solid #EFEFEF">
        <p>
          Dans le cadre du programme APPLIDREP, nous allons recueillir des données à caractère personnel concernant votre enfant : âge, poids, taille, sexe et des données à caractère médical.<br/>
          Ces données sont collectées par l’équipe du centre de la drépanocytose du CHU Robert Debré et traitées par la société IRIADE dans le cadre du programme APPLIDREP.<br/>
          Les données collectées par APPLIDREP sont hébergées en France, par la société COREYE-PICTIME  50 rue Paradis, 75010 Paris, qui possède l’agrément HADS SILVER SANTE, obtenu auprès de l'ASIP Santé, pour l'hébergement des données de santé.
        </p>

        <p class="pt-1">
          Les données personnelles collectées et traitées dans le cadre de ce programme sont <b>strictement confidentielles</b> et sont consultables <b>seulement par l’équipe de Professionnels de santé</b> qui vous encadre et ne pourront en aucun être cédées à des tiers.
        </p>

        <p class="pt-1">
          Vos données pourront être traitées à des fins statistiques pour améliorer nos prestations : dans ce cas, <b>elles seront anonymisées et ne permettront pas votre identification</b>.
        </p>

        <p class="pt-1">
          Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée, vous pouvez accéder aux données vous concernant, les rectifier, demander leur effacement ou exercer votre droit à la limitation du traitement de vos données, Vous pouvez, à tout moment, retirer votre consentement au traitement de vos données à caractère personnel.
        </p>

        <p class="pt-1">
          Ces droits peuvent être exercés en adressant un courrier accompagné d’un justificatif d’identité au Dr Bérengère KOEHL, Centre de la drépanocytose, Hôpital Robert Debré, 48 Bld Sérurier 75019 Paris ou par voie électronique à berengere.koehl@aphp.fr
        </p>

        <p class="pt-1">
          Les données ne peuvent être conservées que pour une durée n’excédant pas la durée nécessaire à la finalité du traitement. Pour déterminer ces délais, le CH Robert Debré s’est servi des règles issues de recommandations de la CNIL, d’obligations règlementaires ou des délais légaux de prescription des éventuelles actions en justice applicables.
        </p>

        <p class="pt-1">
          Les données nécessaires au suivi du programme APPLIDREP et des services associés sont conservées pendant toute la durée de votre participation au programme et jusqu’à expiration des délais de prescriptions légales.
        </p>

        <p class="pt-1">
          Aucune information personnelle de l'utilisateur du site applidrep.iriade.fr n'est publiée à l'insu de l'utilisateur, échangée, transférée, cédée ou vendue sur un support quelconque à des tiers. Seule l'hypothèse du rachat de la société IRIADE et de ses droits permettrait la transmission desdites informations à l'éventuel acquéreur qui serait à son tour tenu de la même obligation de conservation et de modification des données vis-à-vis de l'utilisateur du site applidrep.iriade.fr
        </p>

        <p class="pt-1">
          Les bases de données sont protégées par les dispositions de la loi du 1er juillet 1998 transposant la directive 96/9 du 11 mars 1996 relative à la protection juridique des bases de données.
        </p>

        <p class="pt-1">
          APPLIDREP est un télécoaching numérique édité par : Centre de la drépanocytose-Service d’hématologie Clinique CHU Robert Debré, 48 Bld Serurier, 75019 Paris.<br/>
          APPLIDREP est mis en ligne par la société IRIADE - 10 rue Bossuet 31400 TOULOUSE - contact@iriade.fr, sur la solution logicielle en ligne « Iriade Télésuivi ».
        </p>
      </div>

      <v-btn block
             class="mb-4"
             color="primary"
             :loading="ui.loading"
             @click="submit">
        OUI, je donne mon consentement
      </v-btn>

      <v-btn block
             @click="ui.step = 'no-consent-confirm'"
             :disabled="true">
        NON, je ne consens pas
      </v-btn>
    </div>

    <div v-show="ui.step === 'no-consent-confirm'">
      <h3 class="mt-2 primary--text text-xs-center fw500">Vous ne consentez pas au programme OBE-COACH.</h3>
      <v-textarea placeholder="Pourquoi ? (facultatif)"
                  v-model="reason"></v-textarea>
      <v-btn class="primary"
             block
             @click="submitConsentRejected">Confirmer
      </v-btn>
      <v-btn block
             @click="ui.step = 3">Annuler
      </v-btn>
    </div>

    <div v-show="ui.step === 'rejected-consent'">
      <h3 class="mt-2 primary--text text-xs-center fw500">Merci pour votre retour. Vous pouvez fermer cette page.</h3>
    </div>
  </div>
</template>

<script>
import api from 'api'
import { mapGetters } from 'vuex'
import IriadeDatePickerFormBlock from '../Iriade/Blocks/IriadeFormBlock/Inputs/IriadeDatePickerFormBlock'
import IriadeMaskedTextInput from '../Iriade/IriadeMaskedTextInput'

export default {
  components: {
    IriadeDatePickerFormBlock,
    IriadeMaskedTextInput
  },
  computed: {
    formFilled () {
      return this.user.hypertension && this.user.diabetes && this.user.excess_cholesterol && this.user.height && this.user.max_weight
    },
    ...mapGetters('application', ['application'])
  },

  data () {
    return {
      user: {
        username: '',
        email: '',
        password: null,
        phoneNumber: '',
        medecin_traitant: null,
        diabetologue: null,
        centre_hospitalier: null,
        gender: null,
        birthdate: null,
      },
      reason: '',
      password2: null,
      ui: {
        animate: false,
        loading: false,
        step: 0
      }
    }
  },

  methods: {
    submit () {
      this.ui.loading = true
      api.post('auth/consent', {
        token: this.$route.params.token,
        ...this.user
      })
        .then(() => {
          document.location.reload()
        })
        .catch(err => {
          this.$router.push({ name: 'auth@login' })
        })
        .then(() => {
          this.ui.loading = false
        })
    },

    submitConsentRejected () {
      api.post(`auth/consent/reject/${this.$route.params.token}`, { reason: this.reason })
        .then(() => {
          this.ui.step = 'rejected-consent'
        })
    }
  },

  mounted () {
    this.ui.animate = true
    this.ui.loading = true
    api.get(`auth/signup/${this.$route.params.token}`)
      .then(res => {
        this.user.username = res.data.username
        this.user.email = res.data.email
        this.user.phoneNumber = res.data.phoneNumber
        this.ui.loading = false
      })
      .catch(() => {
        this.$router.push({ name: 'auth@login' })
      })
  }
}
</script>
